import { withSystemRoleCapabilityFallback } from '@/lib/route-access'
import type { Post } from '@/stores/auth-store'

export const MAP_USAGE_FEATURE_LABEL = 'Map usage'

export const canUseMapsForPost = (post: Post | null | undefined) => {
  const capabilities = withSystemRoleCapabilityFallback(post, post?.capabilities)
  return capabilities?.can_use_maps === true
}
